/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import { createStubRequest } from 'lp-redux-api'
import * as Fixtures from 'fixtures'
import getPromoSelectedCardType from 'utils/getPromoSelectedCardType'

// [ Account ]---------------------------------------------------------------
export const createContact = createStubRequest('CREATE_CONTACT', (contact) =>
  console.log(
    '[NOTE]: contact will be created with: ',
    JSON.stringify(contact, null, 2)
  )
)

export const deleteContact = createStubRequest('DELETE_CONTACT', (contact) =>
  console.log(
    '[NOTE]: contact to be deleted: ',
    JSON.stringify(contact, null, 2)
  )
)

export const fetchAccount = createStubRequest('FETCH_ACCOUNT', () => {
  // return Fixtures.fetchAccount
  return Fixtures.fetchPartnerAccount
})

export const fetchContacts = createStubRequest(
  'FETCH_CONTACTS',
  () => Fixtures.fetchContacts
)

export const requestPasswordChange = createStubRequest(
  'REQUEST_PASSWORD_CHANGE',
  (user) => {
    console.log(
      '[NOTE]: password change request will be initiated for: ',
      JSON.stringify(user, null, 2)
    )

    return Fixtures.requestPasswordChangeSuccess
  }
)

export const updateAccount = createStubRequest('UPDATE_ACCOUNT', (account) =>
  console.log(
    '[NOTE]: account will be updated with: ',
    JSON.stringify(account, null, 2)
  )
)

export const updateContact = createStubRequest('UPDATE_CONTACT', (contact) =>
  console.log(
    '[NOTE]: contact will be updated with: ',
    JSON.stringify(contact, null, 2)
  )
)

export const uploadLogo = createStubRequest('UPLOAD_LOGO', (logo) =>
  console.log(
    '[NOTE]: logo upload will be initiated with: ',
    JSON.stringify(logo, null, 2)
  )
)

// [ AOR ]------------------------------------------------------------------
export const fetchAor = createStubRequest('FETCH_AOR', (latLngCoordinates) =>
  console.log(
    '[NOTE]: will request aor information with: ',
    JSON.stringify(latLngCoordinates, null, 2)
  )
)

// [ ARB ]------------------------------------------------------------------
export const updateARBCreditCard = createStubRequest(
  'UPDATE_ARB_CREDIT_CARD',
  (creditCard) =>
    console.log(
      '[NOTE]: will update ARB credit card to: ',
      JSON.stringify(creditCard, null, 2)
    )
)

// [ Stripe Auto Renewal ]--------------------------------------------------
export const enrollStripeAutoRenewal = createStubRequest(
  'ENROLL_STRIPE_AUTO_RENEWAL',
  (autoRenewal) =>
    console.log(
      '[NOTE]: will request Stripe auto-renewal enrollment with: ',
      JSON.stringify(autoRenewal, null, 2)
    )
)

// [Authentication/Authorization]-------------------------------------------
export const verifyMembership = createStubRequest(
  'VERIFY_MEMBERSHIP',
  (membership) => {
    console.log(
      '[NOTE]: will verify membership with: ',
      JSON.stringify(membership, null, 2)
    )
  }
)

// [Billing]----------------------------------------------------------------
export const updateBillingAddress = createStubRequest(
  'UPDATE_BILLING_ADDRESS',
  (billingAddress) =>
    console.log(
      '[NOTE]: will update billing address to: ',
      JSON.stringify(billingAddress, null, 2)
    )
)

// [ Boats ]--------------------------------------------------------------

export const createBoat = createStubRequest('Create_BOAT', (boat) =>
  console.log('[NOTE]: will create  boat to: ', JSON.stringify(boat, null, 2))
)

export const updateBoat = createStubRequest('UPDATE_BOAT', (boat) =>
  console.log('[NOTE]: will update boat to: ', JSON.stringify(boat, null, 2))
)

export const setOldInactiveAndSetNewPrimary = createStubRequest(
  'CHANGE_PRIMARY',
  (oldBoat, newBoat) => {
    oldBoat.primary_boat__c = false
    oldBoat.boat_status__c = 'Inactive'
    newBoat.primary_boat__c = true
    newBoat.boat_status__c = 'Active'
    console.log(
      '[NOTE]: will update OLD Primary Boat to: ',
      JSON.stringify(oldBoat, null, 2),
      '\nAnd the NEW Primary Boat to: ',
      JSON.stringify(newBoat, null, 2)
    )
  }
)

// [ Membership Card ]------------------------------------------------------
export const fetchMembershipCardOrderStatus = createStubRequest(
  'FETCH_MEMBERSHIP_CARD_ORDER_STATUS',
  (membershipId) => Fixtures.fetchMembershipFulfillments,
  { delay: 1000 }
)

export const requestCardReprint = createStubRequest(
  'REQUEST_CARD_REPRINT',
  (membership) =>
    console.log(
      ('[NOTE]: will send card reprint request with: ',
        JSON.stringify(membership, null, 2))
    )
)

// [ Memberships ]----------------------------------------------------------
export const fetchAllMembershipsForAccount = createStubRequest(
  'FETCH_ALL_MEMBERSHIPS_FOR_ACCOUNT',
  (accountId) => {
    return Fixtures.fetchAllMembershipsForAccountActiveEnrolled
    // return Fixtures.fetchAllMembershipsForAccountMultipleMemberships
    // return Fixtures.fetchAllMembershipsForAccountMultipleMembershipsIncludesNullMembershipStatus
    // return Fixtures.fetchAllMembershipsForAccountActiveNotEnrolled
    // return Fixtures.fetchAllMembershipsForAccountActiveSubsidized

    // For this scenario, make sure the member expiration date in the fixture
    // is within 45 days of the membership expiration date.
    // return Fixtures.fetchAllMembershipsForAccountActiveNotEnrolledExpiring

    // For this scenario, make sure the membership expiration date in the fixture
    // is after the current date.
    // return Fixtures.fetchAllMembershipsForAccountExpired

    // return Fixtures.fetchAllMembershipsForAccountCancelled
    // return Fixtures.fetchAllMembershipsForAccountInactive

    // For these scenarios, make sure that the membership effective date in the
    // fixture is later than the current date/time.
    // return Fixtures.fetchAllMembershipsForAccountFutureEnrolled
    // return Fixtures.fetchAllMembershipsForAccountFutureNotEnrolled

    // Trailer care scenarios...
    // return Fixtures.fetchAllMembershipsForAccountActiveTrailerCareUnavailable
    // return Fixtures.fetchAllMembershipsForAccountActiveTrailerCareSingleYearNotEnrolled
    // return Fixtures.fetchAllMembershipsForAccountActiveTrailerCareMultiYearNotEnrolled
    // return Fixtures.fetchAllMembershipsForAccountExpiredTrailerCareSingleYearNotEnrolled
    // return Fixtures.fetchAllMembershipsForAccountExpiredTrailerCareMultiYearNotEnrolled
    // return Fixtures.fetchAllMembershipsForAccountActiveTrailerCareSingleYearBasic
    // return Fixtures.fetchAllMembershipsForAccountActiveTrailerCareMultiYearBasic
    // return Fixtures.fetchAllMembershipsForAccountExpiredTrailerCareSingleYearBasic
    // return Fixtures.fetchAllMembershipsForAccountExpiredTrailerCareMultiYearBasic
    // return Fixtures.fetchAllMembershipsForAccountActiveTrailerCareSingleYearPlus
    // return Fixtures.fetchAllMembershipsForAccountActiveTrailerCareMultiYearPlus
    // return Fixtures.fetchAllMembershipsForAccountExpiredTrailerCareSingleYearPlus
    // return Fixtures.fetchAllMembershipsForAccountExpiredTrailerCareMultiYearPlus
  }
)

export const fetchMembershipAndAor = createStubRequest(
  'FETCH_MEMBERSHIP_AND_AOR',
  (membershipId) => {
    console.log('FETCHING MEMBERSHIP AND AOR for: ', membershipId)
    return Fixtures.fetchMembershipAndAorSuccess
  },
  { delay: 1000 }
)

// [ Membership Kit ]--------------------------------------------------------
export const applyForMembershipKit = createStubRequest(
  'APPLY_FOR_MEMBERSHIP_KIT',
  (contact) => {
    console.log(
      '[NOTE]: will send the following membership kit contact data',
      JSON.stringify(contact, null, 2)
    )
  }
)

// [ Membership Upgrades ]---------------------------------------------------
export const chargeMembershipUpgrade = createStubRequest(
  'CHARGE_MEMBERSHIP_UPGRADE',
  (upgrade) =>
    console.log(
      '[NOTE]: will validate and post membership upgrade with: ',
      JSON.stringify(upgrade, null, 2)
    )
)

// [ New Member Application ]-------------------------------------------------
export const createMembershipApplicationAccount = createStubRequest(
  'CREATE_MEMBERSHIP_APPLICATION_ACCOUNT',
  ({ account, contact, membership }) => {
    console.log(
      '[NOTE]: will create a new account, contact and membership with: ',
      JSON.stringify({ account, contact, membership }, null, 2)
    )
  }
)

export const fetchActivationCodeDetails = createStubRequest(
  'FETCH_ACTIVATION_CODE_DETAILS',
  (activationCode) => Fixtures.activationCodeDetails
)

export const fetchMembershipApplicationAccount = createStubRequest(
  'FETCH_MEMBERSHIP_APPLICATION_ACCOUNT',
  (accountId, membershipId) => Fixtures.membershipApplicationAccount
)

export const fetchProductPrices = createStubRequest(
  'FETCH_PRODUCT_PRICES',
  () => Fixtures.productPrices
)

// The stub promo is treated as valid only on Gold so dev/stub mode can exercise
// both the success path and the INVALID_CARD_TYPE branch by switching cards.
const STUB_PROMO_VALID_CARD_TYPE = 'Gold'

// Use this promo code in a non-renewal flow to hit the INVALID_FLOW_TYPE
// branch in dev/stub mode. Every other code takes the success path.
const STUB_PROMO_RENEWAL_ONLY_CODE = 'RENEWALONLY'

export const fetchPromoCodeDetails = createStubRequest(
  'FETCH_PROMO_CODE_DETAILS',
  ({ promoCode, membershipType, isRenewal }) => {
    const selectedCardType = getPromoSelectedCardType(membershipType)

    if (selectedCardType && selectedCardType !== STUB_PROMO_VALID_CARD_TYPE) {
      const error = new Error('Promo code validation failed')
      error.errors = { _error: 'INVALID_CARD_TYPE' }
      error.response = {
        message: `This promotion code is only valid for: ${STUB_PROMO_VALID_CARD_TYPE}.`,
      }
      throw error
    }

    if (promoCode === STUB_PROMO_RENEWAL_ONLY_CODE && !isRenewal) {
      const error = new Error('Promo code validation failed')
      error.errors = { _error: 'INVALID_FLOW_TYPE' }
      error.response = {
        message: 'This promotion code is only valid for: renew.',
      }
      throw error
    }

    return Fixtures.promoCodeDetails
  }
)

export const updateMembershipApplicationAccount = createStubRequest(
  'UPDATE_MEMBERSHIP_APPLICATION_ACCOUNT',
  ({ account, contact, membership }) => {
    console.log(
      `[NOTE]: will update the existing account, contact and membership with: `,
      JSON.stringify({ account, contact, membership }, null, 2)
    )

    return Fixtures.membershipApplicationAccount
  }
)

export const updateMembershipAssociatedAccount = createStubRequest(
  'UPDATE_MEMBERSHIP_ASSOCIATED_ACCOUNT',
  ({ email, memberNumber }) => {
    console.log(
      `[NOTE]: will reauthorize an account through auth0: `,
      JSON.stringify({ email, memberNumber }, null, 2)
    )

    return Fixtures.membershipApplicationAccount
  }
)

export const lookupExistingContact = createStubRequest(
  'LOOKUP_EXISTING_CONTACT',
  (contactInfo) => ({ contact_exists: false })
)

// [ Programs Participant Application ]------------------------------------------------
export const applyAsAParticipant = createStubRequest(
  'APPLY_AS_NEW_PARTNER',
  (participant) => {
    console.log(
      '[NOTE]: will apply as a new participant with: ',
      JSON.stringify(participant, null, 2)
    )

    // return Fixtures.applyAsNewPartnerAuth0Account
    return Fixtures.applyAsNewPartnerNoAuth0Account
    // return Fixtures.applyAsNewPartnerNoAuth0Check
  }
)

export const createAndLinkAccount = createStubRequest(
  'CREATE_AND_LINK_ACCOUNT',
  (account) => {
    console.log(
      '[NOTE]: will create partner account with: ',
      JSON.stringify(account, null, 2)
    )
    throw new Error('DUPLICATE_TRANSACTION_SUBMITTED')
  }
)

// [ Offers ]----------------------------------------------------------------
export const createOffer = createStubRequest('CREATE_OFFER', (offer) => {
  console.log(
    '[NOTE]: will create offer with: ',
    JSON.stringify(offer, null, 2)
  )
})

export const fetchRandomOffers = createStubRequest(
  'FETCH_RANDOM_OFFERS',
  () => {
    return Fixtures.fetchRandomOffers
  }
)

export const swapMetadata = createStubRequest('LINK_ACCOUNT', (account) => {
  console.log(
    '[NOTE]: will link account with: ',
    JSON.stringify(account, null, 2)
  )
})

export const updateOffer = createStubRequest('UPDATE_OFFER', (offer) => {
  console.log('[NOTE]: will update offer to: ', JSON.stringify(offer, null, 2))
})

// [ Programs ]-------------------------------------------------------
export const fetchAllProgramsForPartner = createStubRequest(
  'FETCH_ALL_PROGRAMS_FOR_PARTNER',
  (accountId) => {
    return Fixtures.fetchAllProgramsForPartner
  }
)

// [ Referrals ]-------------------------------------------------------------
export const createReferral = createStubRequest('CREATE_REFERRAL', (referral) =>
  console.log(
    '[NOTE]: will create referral with: ',
    JSON.stringify(referral, null, 2)
  )
)

export const fetchReferral = createStubRequest('FETCH_REFERRAL', (referral) => {
  return Fixtures.fetchReferralForNewMember
}
)

// [ Savings Club ]-----------------------------------------------------------
export const fetchOfferDetail = createStubRequest(
  'FETCH_OFFER_DETAIL',
  (offerId) => {
    console.log('[NOTE]: fetching offer detail for offer ID: ', offerId)

    return Fixtures.fetchOfferDetail
  }
)

export const searchSavingsClub = createStubRequest(
  'SEARCH_SAVINGS_CLUB',
  (search) => {
    console.log(
      '[NOTE]: will perform Savings Club search with: ',
      JSON.stringify(search, null, 2)
    )

    return Fixtures.featuredOffers
  },
  { delay: 2000 }
)

// [ Sea Care ]-------------------------------------------------------------
export const applyForSeaCare = createStubRequest(
  'APPLY_FOR_SEA_CARE',
  (contact) => {
    console.log(
      '[NOTE]: will send the following Sea Care contact data',
      JSON.stringify(contact, null, 2)
    )
  }
)

// [ Sea Tow as a Gift ]----------------------------------------------------
export const sendSeaTowGift = createStubRequest(
  'SEND_SEA_TOW_GIFT',
  (gift) => {
    console.log(
      '[NOTE]: will send the following to Sea Tow as a gift data',
      JSON.stringify(gift, null, 2)
    )

    return {}
  },
  { delay: 2000 }
)

// [ Trailer Care Addition ]-------------------------------------------------
export const addTrailerCare = createStubRequest(
  'ADD_TRAILER_CARE',
  (trailerCare) => {
    console.log(
      '[NOTE]: will send the following trailer care addition data',
      JSON.stringify(trailerCare, null, 2)
    )

    return {}
  }
)

// [ Stripe Payment ]----------------------------------------------------------
export const fetchStripePaymentIntent = createStubRequest(
  'FETCH_STRIPE_PAYMENT_INTENT',
  (amount) => {
    console.log(
      '[NOTE]: will fetch Stripe payment intent for amount',
      amount
    )
    
    return {
      payment_intent_id: 'pi_test_' + Date.now(),
      status: 'success',
      amount: amount,
    }
  },
  { delay: 500 }
)

export const fetchStripeSetupIntent = createStubRequest(
  'FETCH_STRIPE_SETUP_INTENT',
  (stripeCustomerId) => {
    console.log(
      '[NOTE]: will fetch Stripe setup intent for customer',
      stripeCustomerId
    )
    
    return {
      client_secret: 'seti_test_' + Date.now() + '_secret_' + Math.random().toString(36).substr(2, 9),
      customer_session_client_secret: 'cuss_test_' + Date.now() + '_secret_' + Math.random().toString(36).substr(2, 9),
    }
  },
  { delay: 500 }
)

export const fetchStripeSubscriptions = createStubRequest(
  'FETCH_STRIPE_SUBSCRIPTIONS',
  (stripeCustomerId) => {
    console.log(
      '[NOTE]: will fetch Stripe subscriptions for customer',
      stripeCustomerId
    )
    
    return {
      subscriptions: [
        {
          id: 'sub_test_' + Date.now(),
          status: 'active',
          current_period_end: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString(),
          items: {
            data: [
              {
                price: {
                  id: 'price_test_' + Date.now(),
                  unit_amount: 17000,
                },
              },
            ],
          },
        },
      ],
      schedules: [],
    }
  },
  { delay: 500 }
)

export const cancelStripeSubscription = createStubRequest(
  'CANCEL_STRIPE_SUBSCRIPTION',
  (subscriptionId) => {
    console.log(
      '[NOTE]: will cancel Stripe subscription',
      subscriptionId
    )
    
    return {
      success: true,
      message: 'Subscription cancelled successfully',
    }
  },
  { delay: 500 }
)

export const processPurchase = createStubRequest(
  'PROCESS_PURCHASE',
  (purchase) => {
    console.log(
      '[NOTE]: will process Stripe purchase with data',
      JSON.stringify(purchase, null, 2)
    )

    return {
      account: { id: 'test_account' },
      contacts: [{ id: 'test_contact' }],
      membership: { id: 'test_membership' },
      boats: [{ id: 'test_boat' }],
      opportunities: [{ id: 'test_opportunity' }],
    }
  },
  { delay: 1500 }
)